/***
 * Created on 2023/8/11
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiDelete} from "../../../service/api";

function CheckWarningDialog(props) {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    const removeMutation = useMutation({
        mutationFn: async () => await apiDelete(`/ajax/remote_login_user/inactive`),
        onSuccess: data => {
            console.log('done');
            queryClient.invalidateQueries({
                queryKey: ['get_remote_login_user']
            })
            props.closeModal();
        },
        onError: (error, variables, context) => {
            console.error(error);
        }
    });

    const onSubmit = async () => {
        await removeMutation.mutateAsync();
    }

    return (
        <ModalDialog {...props}
                     title={t('@Inactive logged in devices@')}
                     submitText={t('@Remove All@')}
                     cancelText={t('@Check Now@')}
                     submitAction={onSubmit}>
            <div className="dialog-content">
                <p>{t('@Some of your devices have not used QNAP services over 30 days. Remove this device so it no longer has access to your QNAP account.@')}</p>
            </div>
        </ModalDialog>
    );
}

export default CheckWarningDialog;